import { HeatingDistributionMethod } from '@customer-apps/shared/enums';
import { EnumDictionary } from '@customer-apps/shared/utils';

export const distributionMethodToDefaultTemperatureFlow: EnumDictionary<HeatingDistributionMethod, number> = {
    [HeatingDistributionMethod.Radiator]: 65,
    [HeatingDistributionMethod.RadiatorAndUnderfloor]: 55,
    [HeatingDistributionMethod.Underfloor]: 35
};
